var levels = require('./levels.js');
var formatDate = require('an-format-date');
function textRenderer(config, record) {
  var args = record.args.slice(0);
  for(var i=0, len=args.length; i < len; i++) {
    if (typeof args[i] === 'string') {
      args[i] = args[i].replace(/\x1b\[[^m]+m/g, '');
      args[i] = args[i].replace(/\x1b/g, '');
    }
  }
  if (record.level==levels.INFO && record.verb) {
    args.unshift(record.verb);
  }
  args.unshift('<'+record.name+'>');
  args.unshift(formatDate(record.timestamp, '%d/%M %H:%m:%s'));
  if (record.level==levels.ERROR || record.level==levels.WARNING) {
    console.error.apply(console, args);
  } else {
    console.log.apply(console, args);
  }
}

module.exports = {
  name: 'text',
  build: function(config) {
    return (function(config) {
      return function(log) {
        textRenderer(config, log);
      }
    })(config);
  }
}
